import { useEffect, useState } from 'react';
import { getLatencyP50 } from '@/shared/lib/latency-buffer';

const TICK_MS = 1_000;

export function useLatencyP50(): number | null {
  const [p50, setP50] = useState<number | null>(() => getLatencyP50());

  useEffect(() => {
    const id = setInterval(() => setP50(getLatencyP50()), TICK_MS);
    return () => clearInterval(id);
  }, []);

  return p50;
}
